import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        arrayResultado: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.arrayResultado;
        state[e.target.name] = e.target.value;
        this.setState({ arrayResultado: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const nombre = document.getElementById('nombre').value;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(errores.length);
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        Swal.showLoading();
        authAxios.post("ucaps/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'UCAPS!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/MasterUCAPS");
            })
            .catch(console.log)
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("ucaps/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, arrayResultado: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, arrayResultado } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>EDITAR UCAP</b>)}
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos} id="form">
                                    <div className='row'>
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-6">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input type="hidden" name="id" value={this.props.match.params.id} />
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="nombre" id="nombre" defaultValue={arrayResultado.NOMBRE}
                                                        className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Nombre" aria-describedby="helpId"
                                                        onChange={this.cambioValor}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar UCAP</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterUCAPS"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Editar;